import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import dayjs from 'dayjs';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';
import { patchUserProjectPreference } from '../services/patchUserProjectPreference.service';
import { getProjectsActivityFilterCacheKey } from '../utils/getProjectsActivityFilterCacheKey';
import { getUserProjectPreferenceKey } from '../utils/userProjectPreferences';

export const applyOptimisticUserProjectPreferenceUpdate = createAction(
  'projects/applyOptimisticUserProjectPreferenceUpdate'
);

export const updateUserProjectPreference = createAsyncThunk(
  'projects/updateUserProjectPreference',
  async (
    { project, favorite, hidden, activeEmployerInfo: overrideActiveEmployerInfo },
    { dispatch, getState, requestId }
  ) => {
    const activeEmployerInfo =
      overrideActiveEmployerInfo || selectUserActiveEmployerInfo(getState());
    const now = dayjs().toISOString();
    const preference = {
      businessId: project.business_id,
      projectId: project.id,
      favorite,
      hidden,
      entityType: 'USER_PROJECT_PREFERENCE',
      updatedAt: now,
    };

    const existingPreference =
      getState().projects.userProjectPreferences?.[
        getUserProjectPreferenceKey(preference)
      ];

    const mergedPreference = {
      ...existingPreference,
      ...preference,
      createdAt: existingPreference?.createdAt || now,
    };

    const cacheKey = getProjectsActivityFilterCacheKey(activeEmployerInfo);
    const latestProjectIds =
      (cacheKey &&
        getState().projects.latestUserActiveProjectIdsByEmployer?.[cacheKey]) ||
      [];

    dispatch(
      applyOptimisticUserProjectPreferenceUpdate({
        requestId,
        cacheKey,
        previousPreference: existingPreference || null,
        previousLatestProjectIds: [...latestProjectIds],
        preference: mergedPreference,
      })
    );

    return patchUserProjectPreference({
      preference: mergedPreference,
      activeEmployerInfo,
    });
  }
);
